export const compressImage = (file: File, aspectRatio?: number): Promise<File> => {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.onload = event => {
      const img = new Image()
      img.src = event.target?.result as string
      img.onload = () => {
        const originalWidth = img.naturalWidth
        const originalHeight = img.naturalHeight

        const width = originalWidth
        const height = aspectRatio ? width / aspectRatio : originalHeight
        const canvas = document.createElement('canvas')
        canvas.width = Math.round(width)
        canvas.height = Math.round(height)
        const ctx = canvas.getContext('2d')
        if (!ctx) {
          resolve(file)

          return
        }
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height)

        // Use the original file type for output, fallback to original file if compression fails
        canvas.toBlob(
          blob => {
            if (blob) {
              try {
                const compressedFile = new File([blob], file.name || 'blob', {
                  type: file.type,
                  lastModified: Date.now()
                })
                resolve(compressedFile)
              } catch {
                resolve(file)
              }
            } else {
              resolve(file)
            }
          },
          file.type,
          0.7
        )
      }
      img.onerror = () => resolve(file)
    }
    reader.onerror = () => resolve(file)
    reader.readAsDataURL(file)
  })
}
